<template>
  <div class="details-box">
    <el-dialog
      :before-close="handleClose"
      :title="details.title"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <div class="table-box">
        <iframe
          :src="$previewImg + fileUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["details"],
  data() {
    return {
      dialogVisible: false,
      fileUrl: "",
    };
  },
  watch: {
    details: {
      handler(newValue, oldValue) {
        // 这里不仅可以监听到对象引用的变化，还能监听到对象内部属性的变化
        this.dialogVisible = newValue.dialogVisible;
        // this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
        this.fileUrl = newValue.data.fileUrl;
        // this.fileUrl = newValue.data.fileUrl + `?token=${newValue.data.token}`;

        console.log("$previewImg + fileUrl", this.$previewImg + this.fileUrl);
      },
      deep: true, // 开启深度监听
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="scss" scoped>
.details-box {
  .page-box {
    text-align: right;
  }
}
</style>
